export const ROLES = {
  ADMIN: 'Admin',
  ANALYTICS: 'Analytics',
  CONTENT_EDITOR: 'Content Editor',
  IDENTITY_MANAGER: 'Identity Manager',
  TAG_MANAGER: 'Tag Manager',
  PRODUCTION: 'Production'
};
